import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-arealistmaster',
  template: require('./arealistmaster.component.html'),
  styles: [],
})
export class AreaListMasterComponent implements OnInit {
    @ViewChild('areaListEdit') areaListEdit;
    expDetails: any;
    api: any;
    busy: Subscription;
    addarea:any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    routeData: any = [];
    id: string;
    ID:any;
    routeLists: any;  
    private detailCellRendererParams;
    currentMonth: any;
    private columnDefs;
    private rowData;
    private rowHeight;
    staffTypes: any;
    staff: any;
    designation: any;
    currentDate: any;
    viewModal: boolean = false;
    editModal: boolean = false;
    addModal: boolean = false;
    static parameters = [ApiService, ActivatedRoute, Router]
    constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute) {
        var self = this;
        this.columnDefs = [
            { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Area Name', field: 'Additional_Area' },
            {
                headerName: 'Action', field: "Action", width: 100, pinned: "right"
                , cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = ` <div class="grid_actions">
                        <span class="editBtn grid_actions_item" data-target="#areaListEdit" data-toggle="modal"><i class="icon-edit"></i></span>                        
                    </div>`;
                    // <span class="addBtn grid_actions_item"  data-toggle="modal"><i class="icon-delete"></i></span>
                    var editBtn = eDiv.querySelectorAll('.editBtn')[0];
                    // var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    var addBtn = eDiv.querySelectorAll('.addBtn')[0];
                    editBtn.addEventListener('click', function () {
                        self.viewModal = false;
                        self.editModal = false;
                        self.addModal = true;
                        self.formValueSet(params.data);
                    });
                    // addBtn.addEventListener('click', function () {
                    //     self.inActiveArea(params.data.ID)
                    // });
                    return eDiv
                }
            },
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };        
    }

    editAreaForm = new FormGroup({
        currentvalue: new FormControl('', [Validators.required]),
        newvalue: new FormControl('', [Validators.required]),
    });

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.id = params['id'];
            this.getHQList();
        });
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'Additional Area' });
    }

    formValueSet(data) {
        console.log('this.additionalAreaForm.value.EmployeeName', data);
        this.editAreaForm.controls['currentvalue'].setValue(data.Additional_Area);
        this.addarea = data.Additional_Area;
        this.ID = data.ID;
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.sizeColumnsToFit();
        this.api.hideOverlay();
    }

    getHQList() {
        let id = this.id;
        this.busy = this.apiService.getHQList(id).subscribe((res: any) => {
            this.routeLists = res.data;
            console.log('route Lists', res.data);
            setTimeout(function (self) {
                self.api.sizeColumnsToFit();
            }, 200, this);
        })
    }

    inActiveArea(id) {   
        var data = {ID: id};
        this.apiService.inActiveAreaCountHQWise(data).subscribe((res: any) => {
            alert(res.msg);                
        });
    }
  
    editArea() {
        var Area = (this.editAreaForm.value.newvalue? this.editAreaForm.value.newvalue: "").trim();
        if(Area.length == 0){
            alert("Area can not be blank.");
            return false;
        }
        var data = {
            ID: this.ID,
            newval: Area,
        }
       $("#areaListEdit .close").click();
       this.busy = this.apiService.editAreaCountHQWise(data).subscribe((res: any) => {
            if(res.data[0].flag == 1){
                alert(res.data[0].msg);
                this.getHQList();
                this.editAreaForm.reset();
            } else {
                alert(res.data[0].msg);
            }
        });
    }
}
